import { getConfiguration } from "./configuration";
import { isEntityToBeHiddenByDesc } from "./isEntityToBeHiddenByDesc";

export function isSportToBeHidden(sportId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.hsps;
		const hiddenById = map != null && map[sportId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}
